<template src="../../../components/shared/physicianSearch/BasePresenter.html">

</template>

<script>
    import {basePresenterMixin} from "../../../components/shared/mixins/basePresenterMixin.js";
    import SearchResult from "./SearchResult.vue";
    import SearchMap from "./SearchMap.vue";

    export default {
        name: "SearchPresenter",
        components: {SearchResult, SearchMap},
        mixins: [basePresenterMixin],
        props: {companyId: {type: [Number], required: true}, token: {type: [String], required: true}},
        data() {
            return {
                additionalData: {companyId: this.companyId, token: this.token}
            };
        },
        mounted() {
            this.baseInit();
        }
    }
</script>

<style src="../../../components/shared/physicianSearch/SearchResults.css">

</style>